<template>
  <modal
    name="manage-validation-reason-edit"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="450"
    height="auto"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Create / Edit Validation</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Reason Name</label
            >
            <input
              type="text"
              class="textInputField"
              placeholder="Patient Appointment"
              
            />
          </div>

          <div class="form-group modified-toggle-switch">
            <div class="d-flex align-items-center flex-wrap mb-2">
              <div class="txt--xs txt--off-white mr-3">Status</div>

              <app-toggle
                :checked="all_properties"
                :label="'Active / Inactive'"
                
              >
              </app-toggle>
            </div>
          </div>

        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner 
          class="button button--primary button--sm mr-3"
        >
          Send </ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
// import { ModelSelect, ModelListSelect } from "vue-search-select";
import Toggle from "@/components/toggle";
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "ManageValidationReasonEdit",
  components: {
    AppToggle: Toggle,
    // datetime: Datetime,
    // ModelSelect,
    ButtonWithSpinner,
  },
  data() {
    return {

    };
  },

  methods: {
   
    closeModal() {
      this.resetValidationForm();
      this.$modal.hide("manage-validation-reason-edit");
    },
    
  },
  watch:{
    
  }
};
</script>
